import React, { useContext } from 'react'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { rowHeaderRender } from 'core/utils'
import { getEventDataHeaders } from './../margin-client'
import { getFinalData } from 'marginanalysis/utils'

const EventData = props => {
  const {
    width,
    height,
    CLIENT,
    isEventPlanner = false,
    whatIf = false,
  } = props
  const marginContext = useContext(MarginAnalysisContext)
  const { events } = getFinalData(marginContext, whatIf, isEventPlanner)
  const OaEventIoHeaders = getEventDataHeaders(CLIENT)(width)

  return (
    <div style={{ minHeight: height < 300 ? '200px' : height + 'px' }}>
      <Grid
        // ref={this.GridRef}
        // editMode="cell"
        data={events || []}
        headers={OaEventIoHeaders}
        altBgColor="#ebebeb"
        render={virtualizedGridRenderer({
          // autoFixColByKey,
          rowHeaderRender,
          height: height < 200 ? 200 : height,
          width,
          headerRowHeight: 30,
        })}
        // onSelectionChange={selected => {
        //   this.selectionChange(selected)
        // }}
        // initialSortOptions={sortOptions}
        // sortOptions={sortOptions}
        // sortEnabled={sortEnabled}
        // isEditable={isEditable}
        selectionType="row"
        selectionMode="single"
      />
    </div>
  )
}

export default EventData
